import script from "./conjunctiveQuery.vue?vue&type=script&lang=ts&setup=true"
export * from "./conjunctiveQuery.vue?vue&type=script&lang=ts&setup=true"

import "./conjunctiveQuery.vue?vue&type=style&index=0&id=1f823874&lang=css"

const __exports__ = script;

export default __exports__